// extracted by mini-css-extract-plugin
export var acceptButton = "_13-5";
export var fullContent = "_13-4";
export var link = "_13-6";
export var linkIcon = "_13-7";
export var sideContent = "_13-3";
export var sideImage = "_13-2";
export var sideImageWrapper = "_13-1";
export var splitLayout = "_13-0";